<template>
    <Modal width="740" class-name="vertical-center-modal no-padding" v-model="customMdl">
        <div slot="header" class="title">个性化定制</div>
        <div class="close-btn" slot="close">
            <i class="iconfont icon-pop-close"></i>
        </div>
        <div class="choose-panel" v-if="customs.length">
            <div class="left bg-grey">
                <ul>
                    <li v-for="(custom,index) in customs" :key="index" :class="{'selected':index==selIndex}" @click="selIndex=index">{{custom.part}}</li>
                </ul>
            </div>
            <div class="right">
                <div class="sel-items">
                    <div class="choices">
                        <div class="choice" v-for="(choice, index) in customs[selIndex].choices"
                             @click="toggleSelChoices(choice.productCustomizationId)"
                             :class="{'selected':selChoices.includes(choice.productCustomizationId)}" :key="index">
                            <div class="img-container" @mouseenter="showBigImg($event,imgBaseUrl+choice.coverFile.key)"
                                 @mouseleave="hiddenBigImg">
                                <img :src="imgBaseUrl+choice.coverFile.key" alt="">
                            </div>
                            <p>{{choice.code}}</p>
                            <p>{{choice.name}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="img-big" ref="imgBgShow">
                <img src="" alt="">
            </div>
        </div>
        <div class="footer">
            <button class="red-btn" @click="submit">确 认</button>
        </div>
    </Modal>
</template>
<style scoped>

    .choose-panel {
        height: 380px;
        text-align: left;
        position: relative;
    }

    .choose-panel > div {
        display: inline-block;
        vertical-align: top;
    }

    .choose-panel .left {
        width: 94px;
        height:100%;
        overflow: auto;
    }

    .choose-panel .left li {
        height: 38px;
        color:#555;
        width: 100%;
        text-align: center;
        line-height: 38px;
        cursor: pointer;
        box-sizing:border-box;
        border-left:4px solid transparent;
    }

    .choose-panel .left li.selected {
        background: #FFFFFF;
        color: #308697;
        border-left:4px solid  #308697;
    }

    .choose-panel .right {
        width: 628px;
        height:100%;
        margin-left: -4px;
        border-left: 1px solid #e9eaec;
        padding: 15px;
        position: relative;
        z-index: 2;
        overflow: auto;
    }

    .choose-panel .right .sel-items > p {
        text-align: left;
        padding-left: 10px;
    }

    .choose-panel .right .choices {
        width: 100%;
    }

    .choose-panel .right .choices .choice {
        width: 68px;
        box-sizing: content-box;
        padding: 10px;
        text-align: center;
        cursor: pointer;
        position: relative;
    }

    .img-big {
        position: absolute;
        width: 360px;
        height: 360px;
        top: 0;
        left: 0;
        display: none;
    }

    .choose-panel .right .choices .choice p {
        word-break: break-all;
        color:#555;
    }

    .choose-panel .right .choices .choice .img-container {
        width: 68px;
        height: 68px;
        border-radius: 12px;
        overflow: hidden;
    }
    .choose-panel .right .choices .choice.selected .img-container .img {
        width: 100%;
        height: 100%;
    }

    .choose-panel .right .choices .choice.selected .img-container:before {
        background-image: url('../../images/choice_bg.png');
        background-size: cover;
        width: 68px;
        height: 68px;
        content: '';
        display: block;
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 2;
    }

    .footer {
        padding: 30px 0 40px;
        text-align: center;
    }

    .footer button {
        text-align: center;
        width:145px;
    }
</style>
<style>
    .show-footer-mdl .ivu-modal .ivu-modal-footer {
        display: block;
        text-align: center;
    }
</style>
<script>
    import {imgBaseUrl} from '../../api/common'
    export default{
        data(){
            return {
                customs: [],
                customMdl: false,
                selIndex: 0,
                selChoices: [],
                product:{},
                imgBaseUrl: imgBaseUrl
            }
        },
        methods: {
            submit(){
                this.$emit('customChange', this.selChoices,this.product.id);
                this.customMdl = false;
            },
            open(product, selChoices){
                this.product = product;
                this.customMdl = true;
                this.customs = product.productCustomizations;
                selChoices && (this.selChoices = selChoices);
            },
            showBigImg(e, url){
                this.$refs.imgBgShow.children[0].src = url;
                this.$refs.imgBgShow.style['top'] = e.offsetY - 100 + 'px';
                this.$refs.imgBgShow.style['left'] = e.offsetX + 200 + 'px';
                this.$refs.imgBgShow.style['z-index'] = '3';
                this.$refs.imgBgShow.style.display = 'block';
            },
            hiddenBigImg(){
                this.$refs.imgBgShow.style.display = 'none';
                this.$refs.imgBgShow.style['z-index'] = '0';
            },
            toggleSelChoices(id){
                if(this.selChoices.includes(id)){
                    let index = this.selChoices.indexOf(id);
                    this.selChoices.splice(index,1);
                }else{
                    this.selChoices.push(id);
                }
            }
        }
    }
</script>